import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Date",
  "Request For",
  "Email",
  "Contact Number",
  "Request Status",
  "Account Status",
  "Actions",
];

const Refundtable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/refund/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.reqFor || "N/A"}</td>
                <td>{item?.email || "N/A"}</td>
                <td>{item?.contactNumber || "N/A"}</td>
                <td>
                  <span
                    className={`badge ${
                      item?.reqStatus === "Completed"
                        ? "bg-green"
                        : item?.reqStatus === "Pending"
                        ? "bg-blue"
                        : item?.reqStatus === "Inprocess"
                        ? "bg-yellow"
                        : "bg-blue"
                    }`}
                    style={{ color: "white" }}
                  >
                    {item.reqStatus?.toUpperCase() || "N/A"}
                  </span>
                </td>
                <td>
                  <span
                    className={`badge ${
                      item?.isAccountDisabled ? "bg-red-lt" : "bg-blue-lt"
                    }`}
                  >
                    {item?.isAccountDisabled
                      ? "Disabled"
                      : item?.reqFor === "Site Inspection"
                      ? "A.C Active"
                      : "A.C Not Exist"}
                  </span>
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Refundtable;
